export const STATUS_LABELS = {
    new: "NEW",
    routing: "ROUTING",
    kitchen: "IN KITCHEN",
    ready: "READY",
    collected: "COLLECTED",
};

export const STATUS_ORDER = ["new", "routing", "kitchen", "ready", "collected"];

export const nextStatus = (s) => {
    const idx = STATUS_ORDER.indexOf(s);
    return idx >= 0 && idx < STATUS_ORDER.length - 1 ? STATUS_ORDER[idx + 1] : null;
};

export const NEXT_ACTION_LABEL = {
    new: "Accept & Route",
    routing: "Hand to Kitchen",
    kitchen: "Mark Ready",
    ready: "Mark Collected",
};

export const formatMoney = (n) => `£${Number(n || 0).toFixed(2)}`;

export const minutesAgo = (iso) => {
    if (!iso) return 0;
    const diffMs = Date.now() - new Date(iso).getTime();
    return Math.max(0, Math.floor(diffMs / 60000));
};
